<template>
  <div>
    <a-card>
      <a-form layout="inline" ref="searchForm" :model="form.searchForm" style="margin-bottom: 20px;">
        <a-form-item label="合并状态" name="state">
          <a-select
            style="width: 140px;margin-right: 20px;"
            v-model:value="form.searchForm.state"
            :options="optData.mergeStateOpt"
          >
          </a-select>
        </a-form-item>
        <a-form-item label="关键字" name="keyword">
          <a-input style="width: 200px" placeholder="根据总任务编号/名根据任务编号/任务名称/数据集名称查询称查询" v-model:value="form.searchForm.keyword" autocomplete="off">
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
        </a-form-item>
      </a-form>
      <a-table style="width: 100%;" :scroll="{ x: 1500 }" :dataSource="task.list" :columns="columns" :pagination="false">
        <template v-slot:namemMixinNum="{ record }">
          <div v-for="(label) in record.labelTasks">
            {{ label.name }} (
            <template v-for="(child, cIndex) in label.children">
              {{child.number}}<template v-if="cIndex >0 && cIndex < label.children.length -1">,</template>
            </template> )
          </div>
        
        </template>
        <template v-slot:state="{ record }">
          {{taskSatus[record.state]}}
        </template>
        
      </a-table>
      <div class="mt20">
        <a-pagination
        v-model:current="task.page.num"
        show-quick-jumper
        :pageSize=task.page.size
        :total="task.page.total"
        :show-total="total => `共 ${total} 条`"
        @change="getMergeList"
      ></a-pagination>
      </div>
    </a-card>

  </div>
</template>

/**
 * 
    默认50
 * 
 * 
**/
<script>
const columns = [
  {
    title: '任务编号',
    dataIndex: 'number',
    width:200,
    fixed: 'left',
  },
  {
    title: '标注合并任务名称',
    dataIndex: 'name',
    width:200
  },
  {
    title: '数据标注任务名称(子任务编号)',
    dataIndex: 'type',
    slots: { customRender: 'namemMixinNum' }

  },
  {
    title: '数据集名称',
    dataIndex: 'dataset.chineseInstructions',
    width:200
  },
  {
    title: '说明',
    dataIndex: 'description',
    width:200

  },

  {
    title: '任务状态',
    dataIndex: 'state',
    width:100,
    slots: { customRender: 'state' }

  },
  {
    title: '创建人',
    dataIndex: 'createUserName',
    width:100

  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width:200

  }
]

import {reactive, onMounted, defineAsyncComponent} from "vue";
import { useRouter} from 'vue-router'
import { message } from 'ant-design-vue';
import { useStore } from '@/store/index2'

import {mergeTasks} from '@/api/taskRelease'

export default{
  setup(){
    const router = useRouter()
    let store = useStore()
    let taskSatus = store.taskSatus

    let task = reactive({
      list:[],
      taskFormVisible:false,
      fromType:'creat',
      page:{
        num:1,
        size:10,
        total:0
      },
      taskData:[]
    })


     /*  查询   */
    let form = reactive({
      searchForm:{
        state:'',
        keyword:'',
      }
    })

    let optData = reactive({
      mergeStateOpt:[
        {label:'全部',value:''},
        {label:'进行中',value:'in_progress'},
        {label:'已完成',value:'completed'}
      ],
    })
     
    const search = ()=>{
      task.page.num = 1
      getMergeList()
    }
    
   
    //  任务列表
    const getMergeList = async ()=>{
      task.list = []
      let params = {
        groupId:JSON.parse(localStorage.getItem('westCurrentRole')).teamId,
        keyword:form.searchForm.keyword,
        pageNum:task.page.num,
        pageSize:task.page.size,
        state: form.searchForm.state,
      }
      const {data:res} = await mergeTasks(params)
      if(res.code == 0){
        const list = res.data.records
        task.list = list
        task.page.total = res.data.total
      }
      else{
        message.error(res.msg)
      }
    }

    getMergeList()

    return{   
      task,
      columns,
      form,
      taskSatus,

      getMergeList,


      optData,
      search,

    }
  }
}
</script>


<style lang="less">

</style>
